module.exports = __webpack_public_path__ + "img/double_circle_green.27d70830.png";